import { render, staticRenderFns } from "./TicketAlertsControl.vue?vue&type=template&id=a9ad5296&"
import script from "./TicketAlertsControl.vue?vue&type=script&lang=js&"
export * from "./TicketAlertsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports